import React from 'react';
import { IconProps } from '.';

type PackageIconProps = {
  color?: string;
} & IconProps;

export const PackageIcon: React.FC<PackageIconProps> = ({
  width = 24,
  height = 24,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill={color}
        d="M22.916 7.99a.428.428 0 00-.104-.282l-2.968-4.927a.417.417 0 00-.355-.208H5.552a.437.437 0 00-.365.208l-3 5.084a.616.616 0 000 .135v14.031a.417.417 0 00.417.427h19.99a.417.417 0 00.416-.427V8.073l-.094-.083zM3.323 7.646l2.51-4.24h13.542l2.5 4.24H3.323zm18.843.844v13.197H2.916V8.447l19.25.043z"
      ></path>
      <path
        fill={color}
        d="M9.333 12.927h6.334a.427.427 0 000-.844H9.333a.427.427 0 100 .844z"
      ></path>
      <path
        fill={color}
        d="M16.5 12.083H8.49a.427.427 0 000 .844h8.01a.427.427 0 000-.844z"
      ></path>
    </svg>
  );
};
